export const ANIMATE_HEIGHT = 'animate-height';
